/** @jsx jsx */
import { Box, Flex, jsx } from "theme-ui";
import React, { useEffect, useState } from "react";
import { Link } from "gatsby";
import Navbar from "../../components/navigation/nav-bar";
import CompanyLogo from "../../components/company/company-logo";


export const PageHeader: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);

  //console.log(wp);

  // change state on scroll
  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 45;
      if (isScrolled !== scrolled) {
        setScrolled(!scrolled);
      }
    };

    document.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      // clean up the event handler when the component unmounts
      document.removeEventListener("scroll", handleScroll);
    };
  }, [scrolled]);

  //we are going to have 2 nav's one to the left of the logo and one to the right

  return (
    <Box as="header" variant="header">
      <Box
        sx={{
          height: "100%",
          variant: "layout.box.noPadding",
          px: [2, 0, 0],
        }}
      >
        <Box
          sx={{
            height: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            py: 3,
          }}
        >
          <Link to="/">
            <CompanyLogo />
          </Link>
          <Flex>
            <Navbar />
          </Flex>
        </Box>
      </Box>
    </Box>
  );
};

export default PageHeader;
